import * as React from 'react';
import './PointItem.less';

type Props = {
  title: string;
  value?: string;
  styles?: any;
  testid?: string;
};

const PointItem = ({ title, value, styles, testid }: Props) => (
  <div className="point-item-container" style={styles}>
    <div className="point-item-row">
      <img alt="oval" src="/images/oval.png" className="point-item-oval" />
      <div data-testid={`PointItem-${testid}`} className="point-item-title">
        {' '}
        {title}
      </div>
    </div>
    {value !== '' && <div className="point-item-value">{value}</div>}
  </div>
);

PointItem.defaultProps = {
  value: '',
  styles: null,
};

export default PointItem;
